module.exports = __webpack_public_path__ + "5e3b11a93d8636068b263058956bdf03.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/4000_l_60.mp3
// module id = 443
// module chunks = 0